// extracted by mini-css-extract-plugin
module.exports = {"container":"photoUpload_container__2SENX","pixaBay":"photoUpload_pixaBay__YZAkD"};